import Checkout from '@/pages/Checkout'

export default {
  path: '/checkout',
  name: 'Checkout',
  component: Checkout
}



// WEBPACK FOOTER //
// ./src/router/checkout.js